const e = {
  start: "d-btn-group--start",
  end: "d-btn-group--end",
  "space-between": "d-btn-group--space-between"
};
export {
  e as BUTTON_GROUP_ALIGNMENT
};
//# sourceMappingURL=button-group-constants.js.map
